import { PaletteMode } from '@mui/material';
import { ChronosphereColorPalette, purple } from '../colors';
import { GetThemeOptions } from '@/theme/theme';
import { unityDarkTokens, unityLightTokens } from '@/theme/unityTokens';

export const newColor = (mode: PaletteMode, opts: GetThemeOptions): ChronosphereColorPalette => {
  if (opts.panwRebrandStubYear) {
    return mode === 'light'
      ? {
          main: unityLightTokens['--data-informative-new'],
          highContrast: unityLightTokens['--data-informative-new-high-contrast'],
          lowContrast: unityLightTokens['--data-informative-new-low-contrast'],
        }
      : {
          main: unityDarkTokens['--data-informative-new'],
          highContrast: unityDarkTokens['--data-informative-new-high-contrast'],
          lowContrast: unityDarkTokens['--data-informative-new-low-contrast'],
        };
  }

  return mode === 'light'
    ? {
        main: purple[500],
        highContrast: purple[700],
        lowContrast: purple[100],
      }
    : {
        main: purple[400],
        highContrast: purple[100],
        lowContrast: purple[800],
      };
};
